import Grid from '@material-ui/core/Grid';
import {
  HomePageCompanyLogo,
  HomePageRecentlyVisited,
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageTopVisited,
} from '@backstage/plugin-home';
import { Content, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { makeStyles } from '@material-ui/core';
import { CompanyLogo } from './companylogo';
import { tools } from './tools';
import { LatestNewsCard } from '@internal/backstage-plugin-news';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { useTitle } from 'react-use';

const useStyles = makeStyles(_ => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
  },
}));

export const HomePage = () => {
  const styles = useStyles();
  const config = useApi(configApiRef);
  const isNewsEnabled = config.getOptionalBoolean('news.enabled') ?? false;
  useTitle('Puzzle Backstage');

  return (
    <Page themeId="home">
      <Content>
        <Grid container spacing={4} justifyContent="center">
          <Grid container item xs={12} md={12} justifyContent="center">
            <HomePageCompanyLogo logo={CompanyLogo} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <HomePageSearchBar
              InputProps={{ classes: { root: styles.searchBarInput } }}
              debounceTime={600}
            />
          </Grid>
          <Grid container item xs={12}>
            <Grid item xs={12} md={6}>
              {isNewsEnabled ? <LatestNewsCard /> : <HomePageTopVisited />}
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageRecentlyVisited />
            </Grid>
          </Grid>
          <Grid container item xs={12}>
            <Grid item xs={12} md={6}>
              <HomePageStarredEntities />
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageToolkit tools={tools} />
            </Grid>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
